export default {
  baseURL: process.env.VUE_APP_BASE_URL,
  oftURL: process.env.VUE_APP_OFT_URL
  // authURL: process.env.VUE_APP_AUTH_URL,
  // instanceURL: process.env.VUE_APP_INSTANCE_URL,
  // nxcBaseURL: process.env.VUE_APP_NXC_BASE_URL,
  // clientID: process.env.VUE_APP_CLIENT_ID
}
